module.exports = __webpack_public_path__ + "img/6.fcf2d4f7.jpg";